package kz.dentalcrm.app.screens.appointments.add.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.datetime.LocalDateTime
import kz.dentalcrm.app.core.base.Selectable
import kz.dentalcrm.app.core.ui.InputValue
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.data.network.response_model.PatientData
import kz.dentalcrm.app.data.network.response_model.employees.Employee

data class AddAppointmentViewState(
    val step: Step = Step.First,
    val screenState: ScreenState = ScreenState.Idle,
    val selectedPatient: PatientData? = null,
    val dateFormatted: String? = null,
    val selectDateTime: LocalDateTime? = null,
    val enableCreateAppointment: Boolean = false,
    val appointmentState: AddAppointmentState = AddAppointmentState.Idle,
    val employees: PersistentList<Selectable<Employee>> = persistentListOf(),
    val suggestedPatients: PersistentList<PatientData> = persistentListOf(),
    val searchPatientInput: InputValue = InputValue(),
    val titleInput: InputValue = InputValue(),
) {

    sealed interface AddAppointmentState {
        data object Idle : AddAppointmentState
        data object Loading : AddAppointmentState
    }

    sealed interface Step {
        data object First : Step
        data object Second : Step
        data object Third : Step
        data object Fourth : Step
    }
}
